var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"warns"},[_c('dt',[_c('i',{staticClass:"jc-icon icon-prompt-warning"}),_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('dd',{key:index},[_vm._v(_vm._s(item))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-d8999e88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/warns/index.vue
// module id = null
// module chunks = 